// Tier-2 <Collapse> backed by AntD Collapse (FORT-331). Panels are passed as data
// (items) rather than <Collapse.Panel> children (the AntD v5 contract). onChange
// reports the open key(s). Colours come from the token-sourced theme.
import React from 'react';
import { Collapse as AntCollapse } from 'antd';
import type { CommonProps } from './types';

export interface CollapseItem {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
}

export interface CollapseProps extends CommonProps {
  items: CollapseItem[];
  /** Controlled open panel key(s). */
  activeKey?: string | string[];
  defaultActiveKey?: string | string[];
  onChange?: (key: string | string[]) => void;
  /** Only one panel open at a time. */
  accordion?: boolean;
  bordered?: boolean;
  size?: 'small' | 'middle' | 'large';
}

export const Collapse: React.FC<CollapseProps> = ({
  items,
  activeKey,
  defaultActiveKey,
  onChange,
  accordion,
  bordered = true,
  size = 'middle',
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntCollapse
    items={items}
    activeKey={activeKey}
    defaultActiveKey={defaultActiveKey}
    onChange={onChange}
    accordion={accordion}
    bordered={bordered}
    size={size}
    className={className}
    style={style}
    data-testid={dataTestId}
  />
);
